/* ============================================================
   VITALCASA CRM — FichaResumenPropiedad
   Panel lateral con ficha resumen (p. ej. desde Contactos).

   Props:
   - propiedadId: string (carga por API)
   - datos: object opcional (si ya tienes el shape de ficha, no hace fetch)
   - onClose: () => void
   ============================================================ */
import { useState, useEffect } from "react";
import { cargarDatosFichaResumen } from "./cargarDatosFichaResumen";
import FichaResumenPanel from "./FichaResumenPanel";

export default function FichaResumenPropiedad({ propiedadId, datos: datosProp, onClose }) {
  const [cargando, setCargando] = useState(!datosProp);
  const [propiedad, setPropiedad] = useState(datosProp || null);
  const [datos, setDatos] = useState(datosProp || null);

  useEffect(() => {
    if (datosProp) {
      setPropiedad(datosProp);
      setDatos(datosProp);
      setCargando(false);
      return;
    }
    if (!propiedadId) return;
    setCargando(true);
    cargarDatosFichaResumen(propiedadId)
      .then((loaded) => {
        setPropiedad(loaded);
        setDatos(loaded);
      })
      .catch(console.error)
      .finally(() => setCargando(false));
  }, [propiedadId, datosProp]);

  return <FichaResumenPanel p={propiedad} d={datos} onClose={onClose} cargando={cargando} />;
}
